import { FaCheck } from "react-icons/fa6";
import Subtitle from "../ui/subtitle";

const Features = ({ title, subtitle, description, list }) => {
  return (
    <section className="bg-gradient-to-br from-blue-50 via-white to-white">
      <div className="mx-auto max-w-screen-xl px-5 py-10">
        <Subtitle subtitle={title} center={true} />
        <h2 className="mb-2.5 text-center text-3xl font-bold !leading-tight tracking-tight text-slate-900 md:text-5xl lg:mb-0">
          {subtitle}
        </h2>
        <p className="mx-auto mt-2.5 text-center lg:w-2/3 lg:text-lg">
          {description}
        </p>
        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((feature) => (
            <div
              key={feature.title}
              className="rounded-3xl border bg-white shadow-sm"
            >
              <h4 className="flex items-center gap-2 border-b p-5 font-bold">
                <FaCheck className="text-blue-500" />
                {feature.title}
              </h4>
              <p className="px-5 py-3.5">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
